// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// SaveProgramClassificationDetailsHandler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import ProgramClassificationDTO from '../models/ProgramClassificationDTO';
import ResultDTO from '../models/ResultDTO';

interface Request {
    programClassificationId: number;
    programClassification: ProgramClassificationDTO | null;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            programClassificationId: 0,
            programClassification: null,
        },
        initValues);
    },
    programClassificationId: 'programClassificationId',
    programClassification: 'programClassification',
}

interface Result extends ResultDTO {
    programClassification: ProgramClassificationDTO | null;
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
            programClassification: null,
        },
        initValues);
    },
    programClassification: 'programClassification',
}

export { Request, Result };